import axios, { AxiosError } from "axios";
import { apiProvider } from "../Provider";

const UNAUTHORIZED = 401;

const instance = axios.create({});

const getToken = () => {
  let token = "";
  if (typeof window !== "undefined") {
    const authString = localStorage && localStorage.getItem("auth");
    if (authString) {
      const auth = JSON.parse(authString);
      if (auth) {
        token = `Bearer ${auth.token}`;
      }
    }
  }
  return token;
};
instance.interceptors.request.use(function(config) {
  config.withCredentials = true;
  return config;
});

instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response) {
      const { status } = error.response;
      if (
        status === UNAUTHORIZED &&
        error.response.data.errors[0] === "jwt expired"
      ) {
        const obj = {};
        try {
          await apiProvider.post(`user/refresh`, obj);
          return instance(error.config);
        } catch (err) {
          try {
            await apiProvider.post("user/logout", {});
            window.location.replace("/");
          } catch (err) {
            console.log(err);
          }
        }
      }
      return Promise.reject(error);
    }
  }
);

export { instance };
